// extracted by mini-css-extract-plugin
module.exports = {"modal":"ItemCarousel-module--modal--3GcfN","recDot":"ItemCarousel-module--rec-dot--2PxsF","recDot_active":"ItemCarousel-module--rec-dot_active--3sWSZ"};